import * as React from 'react';
import { FormattedPlural, useIntl } from 'react-intl';

import messages from '../../../messages';

export const ReviewsPlural = ({
  productReviewCount,
}: {
  productReviewCount: number;
}) => {
  const { formatMessage } = useIntl();
  return (
    <FormattedPlural
      value={productReviewCount}
      one={formatMessage(messages.totalReviewsOne)}
      other={formatMessage(messages.totalReviewsOther)}
      few={formatMessage(messages.totalReviewsFew)}
    />
  );
};
